<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="producselect" :key="index" :options="item.options"
						:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
				</div>
				<div class="Btngroups">
					<CommonBtngroup :qhide="false" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>

			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Productfiletable :tableData="tableData" :total="total" @export="exportData"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></Productfiletable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Productfiletable from './components/productfiletable.vue'
	import utils from '../../../common/utils'
	import {
		InventoryClassList
	} from '@/api/home'
	import {
		GetInventoryClassNTSQuotaList,
		ExportInventoryClassNTSQuota
	} from '@/api/newsapi'

	export default {
		components: {
			Commondropdownlist,
			Productfiletable,
			CommonBtngroup
		},
		data() {
			return {
				total: 0,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				showorhide: true,
				invClass: "",
				createTime1: "",
				createTime2: "",
				formdata: [{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '64px',
						options: []
					},
					{
						inputdata: '',
						title: '创建时间',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: 'daterange',
						inputtype: 'date',
						width: '380px',
						lablewith: '110px'
					}
				]
			}
		},
		mounted() {
			this.getInvClassList()
			this.getList()
		},
		methods: {
			async getInvClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.formdata[0].options = data.data.map(item => ({
						key: item.InvClass,
						value: item.InvClassName
					}))
				}
			},
			async getList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let params = {
					InvClass: this.invClass,
					CreateTime1: this.createTime1,
					CreateTime2: this.createTime2,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				}
				let {
					data,
					code,
					message
				} = await GetInventoryClassNTSQuotaList(params)
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data || []
				} else {
					this.$message.error(message)
				}
				loading.close();
			},
			async exportData() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let res = await ExportInventoryClassNTSQuota({
					InvClass: this.invClass,
					CreateTime1: this.createTime1,
					CreateTime2: this.createTime2
				})
				if (res) {
					utils.downloadFile(res, `产品线NTS配额导出_${new Date().getTime()}`, "xlsx")
				} else {
					this.$message.warning('导出失败')
				}
				loading.close()
			},
			select() {
				this.pageindex = 1
				this.invClass = this.$refs.producselect[0].modelvalue
				this.createTime1 = this.$refs.producselect[1].startTime
				this.createTime2 = this.$refs.producselect[1].endTime
				this.getList()
			},
			reset() {
				this.$refs.producselect[0].modelvalue = ''
				this.$refs.producselect[1].startTime = ''
				this.$refs.producselect[1].endTime = ''
				this.invClass = ""
				this.createTime1 = ""
				this.createTime2 = ""
				this.pageindex = 1
				this.getList()
			},
			hide() {
				this.showorhide = !this.showorhide
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.getList()
			},
			handleSizeChange(pageSize) {
				this.pageSize = pageSize
				this.getList()
			}
		}
	}
</script>

<style lang="less" scoped>
	.inputtop,
	.inputtops {
		width: 100%;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding: 15px 0px;
		transition: all 0.3s;
		overflow: hidden;
		position: relative;
	}

	.inputtops {
		height: 50px;
	}

	.Btngroups {
		float: right;
	}
</style>